export default {
  pages: {
    shipment: {
      title: 'Отгрузка товаров',
      tabs: ['Отгрузить товары', 'Накладные'],
      itemsToShipment: 'Товары на отгрузку',
      shipmentTime: 'Время отгрузки',
      waybillGeneration: 'Сгенерировать накладную',
      items: 'товаров',
      addItem: 'Добавить товар',
      quantity: 'Количество',
      successResponse: 'Успешно забранировано',
    },
  },
};
